<template>
    <div>
        <Header>
            <div class="headertitle">
                <a href="/" class="headertitle-home" title="Home" aria-label="Home">
                    <i class="fas fa-home" aria-hidden="true"></i>
                </a>
                <a href="/">
                    INTERNATIONAL ARCHITECTURE<span class="copyright"
                        >&#174;</span
                    >
                    AWARD
                </a>
            </div>
        </Header>
        <el-row :gutter="15">
            <el-col :xs="24" :sm="6" :lg="4">
                <div class="side-menu-frame" v-if="$auth.user()">
                    <router-link :to="accountLink">Account</router-link>
                    <div @click="reloadPageWhenRouteTheSame()">
                        <router-link
                            :to="{
                                name: 'international-architecture-award-form',
                            }"
                            >New Submission</router-link
                        >
                    </div>
                    <router-link :to="submissionLink"
                        >My Submissions</router-link
                    >
                </div>
                <div v-else>&nbsp;</div>
            </el-col>
            <el-col :xs="24" :sm="18" :lg="12">
                <router-view></router-view>
            </el-col>
        </el-row>
        <FooterAlt>
            <div class="footerlogo-caption">
                INTERNATIONAL ARCHITECTURE™ is a Federally Registered and
                Protected U.S. Trademark of The Chicago Athenaeum. Copyright ©
                1992 - 2026
                <BR />The Chicago Athenaeum
            </div>
            <img src="/images/INTERNATIONAL-ARCHITECTURE-LOGO.png" />
        </FooterAlt>
    </div>
</template>

<script>
import FormStep from "./FormStep";
import PaymentStep from "./PaymentStep";
import ThankyouStep from "./ThankyouStep";
import formApi from "../api";
import Header from "@/core/components/Header";
import FooterAlt from "@/core/components/FooterAlt";

export default {
    components: {
        FormStep,
        PaymentStep,
        ThankyouStep,
        Header,
        FooterAlt,
    },
    methods: {
        reloadPageWhenRouteTheSame() {
            if (
                this.$router.currentRoute.name !== "front-account" &&
                this.$router.currentRoute.name !== "front-submissions"
            ) {
                this.$router.go();
            } else {
                this.$router.push(this.$route.matched[1].path);
            }
        },
        handleSubmitForm() {
            let self = this;
            if (self.submittedFormId) {
                self.processPayment();
            } else {
                this.loading = true;
                formApi
                    .save(this.formData, this.formType)
                    .then(function (response) {
                        if (response && response.data && response.data.id) {
                            self.submittedFormId = response.data.id;
                            self.processPayment();
                        } else {
                            alert(
                                "Unfortunately, we could not save the form. Please try again."
                            );
                        }
                    })
                    .catch(function (error) {
                        alert(
                            "Oops, it appears that something went wrong! Please try again!"
                        );
                    })
                    .then(() => {
                        this.loading = false;
                    });
            }
        },
        processPayment() {
            if (this.formData.payment.method == "bank") {
                this.currentStep += 1;
            } else {
                this.pay();
            }
        },
        pay() {
            let self = this;
            self.loading = true;
            self.paymentAttempt += 1;
            let callbacks = {
                onError: function (error) {
                    alert(
                        "Oops, our payment gateway could not process your card. Please try again, or choose another payment method."
                    );
                    self.loading = false;
                    formApi.savePaymentAttempt(
                        self.submittedFormId,
                        "error",
                        error
                    );
                },
                onDeclined: function (response) {
                    alert(
                        "Unfortunately, your card was not accepted. Please check with your issuer bank if there is any problem, try with another card, or try another payment method."
                    );
                    self.loading = false;
                    formApi.savePaymentAttempt(
                        self.submittedFormId,
                        "declined",
                        JSON.stringify(response)
                    );
                },
                onApproval: function (response) {
                    formApi
                        .savePaymentAttempt(
                            self.submittedFormId,
                            "approved",
                            JSON.stringify(response)
                        )
                        .then(function (response) {})
                        .catch(function (error) {})
                        .then(() => {
                            self.currentStep += 1;
                            self.loading = false;
                        });
                },
            };
            formApi
                .getPaymentToken(self.submittedFormId)
                .then(function (response) {
                    if (response && response.data && response.data.token) {
                        let paymentData = {
                            ssl_txn_auth_token: response.data.token,
                            ssl_card_number:
                                self.formData.payment.cardnumber.replace(
                                    /\D/g,
                                    ""
                                ),
                            ssl_exp_date:
                                self.formData.payment.cardmonth +
                                self.formData.payment.cardyear,
                            ssl_get_token: "Y",
                            ssl_add_token: "Y",
                            ssl_first_name: self.formData.billing.firstname,
                            ssl_last_name: self.formData.billing.lastname,
                            ssl_cvv2cvc2: self.formData.payment.cvv,
                            ssl_merchant_txn_id:
                                "LIDE#" +
                                self.submittedFormId +
                                "_" +
                                self.paymentAttempt,
                        };
                        self.loading = true;
                        window.ConvergeEmbeddedPayment.pay(
                            paymentData,
                            callbacks
                        );
                    } else {
                        self.loading = false;
                        if (response.data && response.data.message) {
                            alert(response.data.message);
                        } else {
                            alert(
                                "Unfortunately, we could not process the card payment. Please try again, or choose another payment method."
                            );
                        }
                    }
                })
                .catch(function (error) {
                    self.loading = false;
                    alert(
                        "Oops, it appears that something went wrong! Please try again, or choose another payment method."
                    );
                });
        },
    },
    data: () => ({
        loading: false,
        currentStep: 0,
        submittedFormId: "",
        paymentAttempt: 0,
        formType: "internationalarchitecture",
        steps: [
            "applicant",
            "architect",
            "client",
            "contractor",
            "associate_architect",
            "project_details",
            "billing",
            "payment",
            "thankyou",
        ],
        title: window.config.appName,
        formData: {
            applicant: {
                gender: null,
                firstname: "",
                lastname: "",
                company_name: "",
                job_title: "",
                phone_number: "",
                fax: "",
                email: "",
                web_address: "",
                address1: "",
                address2: "",
                country: "",
                state_region: "",
                city: "",
                postcode: "",
                applying_as: null,
                newsletter: null,
            },
            architect: {
                gender: null,
                firstname: "",
                lastname: "",
                company_name: "",
                job_title: "",
                phone_number: "",
                fax: "",
                email: "",
                web_address: "",
                address1: "",
                address2: "",
                country: "",
                state_region: "",
                city: "",
                postcode: "",
                sameAsApplicant: false,
            },
            client: {
                gender: null,
                firstname: "",
                lastname: "",
                company_name: "",
                job_title: "",
                phone_number: "",
                fax: "",
                email: "",
                web_address: "",
                address1: "",
                address2: "",
                country: "",
                state_region: "",
                city: "",
                postcode: "",
                sameAsApplicant: false,
            },
            contractor: {
                gender: null,
                firstname: "",
                lastname: "",
                company_name: "",
                job_title: "",
                phone_number: "",
                fax: "",
                email: "",
                web_address: "",
                address1: "",
                address2: "",
                country: "",
                state_region: "",
                city: "",
                postcode: "",
                sameAsApplicant: false,
            },
            associate_architect: {
                gender: null,
                firstname: "",
                lastname: "",
                company_name: "",
                job_title: "",
                phone_number: "",
                fax: "",
                email: "",
                web_address: "",
                address1: "",
                address2: "",
                country: "",
                state_region: "",
                city: "",
                postcode: "",
                sameAsApplicant: false,
            },
            project_details: {
                category: "",
                project_title: "",
                year_of_production: "",
                state_country_of_production: "",
                architect_name: "",
                client: "",
                contractor: "",
                photographer: "",
                design_team: "",
                lead_architects: "",
                landscape_architects: "",
                other: "",
                video_link: "",
                images: [],
                floorplans: [],
                project_description: "",
            },
            billing: {
                gender: null,
                firstname: "",
                lastname: "",
                company_name: "",
                vat_id: "",
                phone_number: "",
                fax: "",
                email: "",
                web_address: "",
                address1: "",
                address2: "",
                country: "",
                state_region: "",
                city: "",
                postcode: "",
                sameAsApplicant: false,
            },
            payment: {
                method: "card",
                cardnumber: null,
                cardmonth: null,
                cardyear: null,
                cvv: null,
            },
        },
    }),
};
</script>
